import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';
import moment from 'moment';

const DEFAULTS = {
    date: moment().format('YYYY-MM-DD'),
    type: "FIRST",
}

const isValid = (settlementOptions) => {
    return settlementOptions && settlementOptions.type && settlementOptions.date;
}

const CHANGE_SETTLEMENT_OPTIONS = 'DBM/UI/SETTLEMENT/CHANGE_OPTIONS';

export const actionTypes = {
    CHANGE_SETTLEMENT_OPTIONS
};

const changeSettlementOptions = createAction(CHANGE_SETTLEMENT_OPTIONS, settlementOptions => ({settlementOptions}));
export const actions = {
    changeSettlementOptions
};

export const reducer = handleActions({
    [system.INIT]: () =>
        (state) => {
            return state.setIn(['ui', 'settlement', 'options'], DEFAULTS);
        }
    ,

    [CHANGE_SETTLEMENT_OPTIONS]: (payload) =>
        (state) => {
            if (isValid(payload.settlementOptions)) {
                return state.setIn(['ui', 'settlement', 'options'], payload.settlementOptions);
            } else {
                return state.setIn(['ui', 'settlement', 'options'], DEFAULTS);
            }
        }
});

const getSettlementOptions = (state) => state.getIn(['ui', 'settlement', 'options']);


export const selectors = {
    getSettlementOptions
};
